import { up, down } from 'slide-element';
import clickOutside from 'click-outside';
import announcer from './aria-announcer';

document.addEventListener('DOMContentLoaded', () => {
    const $button = document.querySelectorAll('.btn-connexion');
    const $loginPanel = document.querySelector('.l-header-login');
    const $mobileContainer = document.querySelector('.nav-mobile-header-utils');
    const $desktopContainer = document.querySelector('.nav-desktop-login');

    const moveLoginPanel = () => {
        const isTouchDevice = window.matchMedia('(hover: none)').matches;
        const isMobileView = window.innerWidth < 1140 || isTouchDevice;

        // Move panel to mobile container
        if (isMobileView) {
            if ($loginPanel.parentNode !== $mobileContainer) {
                $mobileContainer.appendChild($loginPanel);
            }
            return;
        }

        // Move back panel to desktop container
        if ($loginPanel.parentNode !== $desktopContainer) {
            $desktopContainer.appendChild($loginPanel);
        }
    };

    // on load
    moveLoginPanel();

    // On resize
    window.addEventListener('resize', moveLoginPanel);

    $button.forEach((button) => {
        let removeClickOutside = null;
        let removeEscapeListener = null;
        let removeFocusOutListener = null;

        const closePanel = (shouldAnnounce) => {
            button.classList.remove('is-active');
            up($loginPanel);
            if (shouldAnnounce) {
                announcer.announce(`Le panneau ${button.textContent} est fermé`);
            }
            // Clean up event listeners
            if (removeClickOutside) {
                removeClickOutside();
                removeClickOutside = null;
            }
            if (removeEscapeListener) {
                removeEscapeListener();
                removeEscapeListener = null;
            }
            if (removeFocusOutListener) {
                removeFocusOutListener();
                removeFocusOutListener = null;
            }
        };

        button.addEventListener('click', (event) => {
            event.stopPropagation();

            const isActive = button.classList.toggle('is-active');

            if (isActive) {
                down($loginPanel);
                announcer.announce(`Le panneau ${button.textContent} est ouvert`);
                // Close on click outside
                removeClickOutside = clickOutside($loginPanel, closePanel);

                // Close on Escape key
                const handleEscape = (e) => {
                    if (e.key === 'Escape') {
                        closePanel(true);
                    }
                };
                document.addEventListener('keydown', handleEscape);
                removeEscapeListener = () => {
                    document.removeEventListener('keydown', handleEscape);
                };

                // Close when focus leaves the panel
                const handleFocusOut = (e) => {
                    // Check if the new focus target is outside the panel
                    if (!$loginPanel.contains(e.relatedTarget)) {
                        closePanel(false);
                    }
                };
                $loginPanel.addEventListener('focusout', handleFocusOut);
                removeFocusOutListener = () => {
                    $loginPanel.removeEventListener('focusout', handleFocusOut);
                };
            } else {
                closePanel(true);
            }
        });

        $loginPanel.addEventListener('click', (event) => {
            event.stopPropagation();
        });
    });
});
